import React from "react";
import order from "../assets/myOrders/OrderEmpty.png";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const SamplePage = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  return (
    <div>
      <div className="text-center">
        <img
          src={order}
          className=" max-lg:w-[230px] lg:w-[400px] mx-auto mt-24 max-lg:mt-10"
        />
        <h2 className="text-[#283D63] text-2xl sm:text-3xl md:text-4xl font-semibold leading-relaxed">
          {t("Coming Soon")}
        </h2>
        <p className="text-[#737E91] mt-4">
          {t("stay tuned")}
        </p>
      </div>
      <div className="flex mx-auto">
        <Link
          to="/"
          className="bg-[#FE9B71] text-white rounded-full px-10 py-3 my-8  mx-auto"
        >
          {t("Home page")}
        </Link>
      </div>
    </div>
  );
};

export default SamplePage;
